// import { useState, useEffect} from "react";
// import {  Icon, apiFetch,  CAMPS_API, Loader } from "./apihandler";

// function CampSelectionPage({ selectedCamp, onSelect, onConfirm }) {
//   const [camps, setCamps] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     apiFetch(CAMPS_API)
//       .then(data => { setCamps(Array.isArray(data) ? data : data.results || []); setLoading(false); })
//       .catch(e => { setError(e.message); setLoading(false); });
//   }, []);

//   const statusPill = (camp) => {
//     const s = (camp.status || "").toLowerCase();
//     if (s === "active" || s === "ongoing") return <span className="pill pill-live">Active</span>;
//     if (s === "upcoming") return <span className="pill pill-amber">Upcoming</span>;
//     if (s === "completed") return <span className="pill pill-green">Completed</span>;
//     return <span className="pill pill-gray">{camp.status || "—"}</span>;
//   };

//   return (
//     <div className="page">
//       <div className="ph"><Icon n="mapPin" size={18} /> Select a Camp</div>
//       <div className="info-note">
//         <Icon n="info" size={15} />
//         <span>All technician assignments, work progress, and payments are scoped to the selected camp.</span>
//       </div>

//       {loading && <Loader text="Fetching camps…" />}
//       {error && <div className="card" style={{ color: "var(--red)", fontSize: 13 }}>Failed to load camps: {error}</div>}

//       {!loading && !error && camps.length === 0 && (
//         <div className="empty">No active camps found.</div>
//       )}

//       <div className="camp-grid">
//         {camps.map((c, i) => (
//           <div
//             key={c.id}
//             className={`camp-card${selectedCamp?.id === c.id ? " selected" : ""}`}
//             onClick={() => onSelect(c)}
//           >
//             <div className="camp-top">
//               <div>
//                 <div className="camp-name">{c.name || c.camp_name || `Camp #${c.id}`}</div>
//                 {(c.location || c.city) && (
//                   <div className="camp-meta"><Icon n="mapPin" size={12} /> {c.location || c.city}</div>
//                 )}
//                 {(c.start_date || c.date) && (
//                   <div className="camp-meta" style={{ marginTop: 2 }}>
//                     <Icon n="clock" size={12} />
//                     {c.start_date}{c.end_date ? ` – ${c.end_date}` : ""}
//                   </div>
//                 )}
//               </div>
//               {statusPill(c)}
//             </div>
//             <div className="camp-stats">
//               {c.technician_count !== undefined && (
//                 <div className="cs-item"><Icon n="users" size={12} /> {c.technician_count} technicians</div>
//               )}
//               {c.service_count !== undefined && (
//                 <div className="cs-item"><Icon n="check" size={12} /> {c.service_count} services</div>
//               )}
//               {c.patient_count !== undefined && (
//                 <div className="cs-item"><Icon n="stethoscope" size={12} /> {c.patient_count} patients</div>
//               )}
//             </div>
//           </div>
//         ))}
//       </div>

//       <div className="btn-row">
//         <button
//           className="btn btn-pri"
//           disabled={!selectedCamp}
//           style={!selectedCamp ? { opacity: .45, cursor: "not-allowed" } : {}}
//           onClick={onConfirm}
//         >
//           Continue with selected camp <Icon n="arrowR" size={15} />
//         </button>
//       </div>
//     </div>
//   );
// }

// export default CampSelectionPage;

import { useState, useEffect, useRef } from "react";
import { Icon, apiFetch, CAMPS_API, Loader } from "./apihandler";

function CampSelectionPage({ selectedCamp, onSelect, onConfirm }) {
  const [camps, setCamps]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [search, setSearch]     = useState("");
  const [activeFilter, setFilter] = useState("ALL");
  const searchRef = useRef(null);

  useEffect(() => {
    apiFetch(CAMPS_API)
      .then(data => { setCamps(Array.isArray(data) ? data : data.results || []); setLoading(false); })
      .catch(e  => { setError(e.message); setLoading(false); });
  }, []);

  /* ── helpers ── */
  const getStatus = (c) => {
    const s = (c.status || "").toLowerCase();
    if (s === "active" || s === "ongoing") return "active";
    if (s === "upcoming")                  return "upcoming";
    if (s === "completed")                 return "completed";
    return "other";
  };

  const FILTERS = ["ALL", "active", "upcoming", "completed"];
  const FILTER_LABEL = { ALL: "All", active: "Active", upcoming: "Upcoming", completed: "Completed" };
  const PILL = {
    active:    { bg: "#e0f5f4", color: "#0c7a77", dot: "#11a8a4" },
    upcoming:  { bg: "#fef3e0", color: "#8c5e00", dot: "#f5a623" },
    completed: { bg: "#eaf3de", color: "#3b6d11", dot: "#6aab2e" },
    other:     { bg: "#f0f0f0", color: "#666",    dot: "#aaa"    },
  };

  const filtered = camps.filter(c => {
    const q = search.toLowerCase();
    const matchSearch = !q || [c.name, c.camp_name, c.location, c.city, c.district, c.state]
      .some(v => v && v.toLowerCase().includes(q));
    const matchFilter = activeFilter === "ALL" || getStatus(c) === activeFilter;
    return matchSearch && matchFilter;
  });

  const counts = { ALL: camps.length };
  camps.forEach(c => { const s = getStatus(c); counts[s] = (counts[s] || 0) + 1; });

  return (
    <>
      <style>{`
        .csp-wrap{display:flex;flex-direction:column;height:100vh;max-height:100dvh;
          background:#f5f7f7;font-family:Inter,system-ui,sans-serif;overflow:hidden}

        /* ── header ── */
        .csp-header{padding:16px 18px 0;flex-shrink:0}
        .csp-title{display:flex;align-items:center;gap:8px;font-size:17px;
          font-weight:700;color:#1a1a1a}
        .csp-sub{font-size:12px;color:#999;margin-top:3px;margin-left:26px}

        /* ── search bar ── */
        .csp-search-row{padding:12px 18px 0;flex-shrink:0;display:flex;gap:8px}
        .csp-search{flex:1;position:relative}
        .csp-search input{width:100%;padding:9px 12px 9px 34px;border:0.5px solid #ddd;
          border-radius:9px;font-size:13px;background:#fff;color:#222;
          outline:none;transition:border .15s;box-sizing:border-box}
        .csp-search input:focus{border-color:#11a8a4;box-shadow:0 0 0 3px #11a8a422}
        .csp-search-icon{position:absolute;left:10px;top:50%;transform:translateY(-50%);
          color:#aaa;pointer-events:none}
        .csp-search input::placeholder{color:#bbb}
        .csp-clear{position:absolute;right:10px;top:50%;transform:translateY(-50%);
          color:#aaa;cursor:pointer;font-size:16px;border:none;background:none;padding:0}

        /* ── filter chips ── */
        .csp-filters{padding:10px 18px 0;display:flex;gap:6px;flex-shrink:0;overflow-x:auto}
        .csp-filters::-webkit-scrollbar{display:none}
        .csp-chip{padding:5px 12px;border-radius:20px;font-size:12px;font-weight:500;
          cursor:pointer;white-space:nowrap;transition:all .15s;border:0.5px solid #ddd;
          background:#fff;color:#777;display:flex;align-items:center;gap:5px}
        .csp-chip.on{border-color:#11a8a4;background:#e0f5f4;color:#0c7a77}
        .csp-chip-count{background:#eee;border-radius:20px;padding:1px 6px;
          font-size:10px;font-weight:600;color:#888}
        .csp-chip.on .csp-chip-count{background:#b8e8e6;color:#0c7a77}

        /* ── results count ── */
        .csp-result-meta{padding:8px 18px 0;font-size:12px;color:#aaa;flex-shrink:0}

        /* ── scrollable list ── */
        .csp-list{flex:1;overflow-y:auto;padding:8px 18px 0;min-height:0}
        .csp-list::-webkit-scrollbar{width:3px}
        .csp-list::-webkit-scrollbar-thumb{background:#ddd;border-radius:3px}

        /* ── camp row card ── */
        .csp-row{display:flex;align-items:center;gap:12px;padding:12px 14px;
          background:#fff;border-radius:11px;border:0.5px solid #e5e5e5;
          margin-bottom:8px;cursor:pointer;transition:all .15s;position:relative}
        .csp-row:hover{border-color:#11a8a4;box-shadow:0 2px 8px #11a8a418}
        .csp-row.sel{border:1.5px solid #11a8a4;background:#e0f5f4}
        .csp-row-avatar{width:40px;height:40px;border-radius:10px;background:#f0fafa;
          display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0}
        .csp-row.sel .csp-row-avatar{background:#b8e8e6}
        .csp-row-body{flex:1;min-width:0}
        .csp-row-name{font-size:14px;font-weight:600;color:#1a1a1a;
          white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
        .csp-row-meta{font-size:12px;color:#aaa;margin-top:2px;
          white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
        .csp-row-dates{font-size:11px;color:#bbb;margin-top:2px}
        .csp-row-right{display:flex;flex-direction:column;align-items:flex-end;
          gap:5px;flex-shrink:0}

        /* ── status pill ── */
        .csp-pill{font-size:10px;font-weight:600;padding:3px 9px;border-radius:20px;
          display:flex;align-items:center;gap:4px}
        .csp-dot{width:5px;height:5px;border-radius:50%;flex-shrink:0}

        /* ── selected check ── */
        .csp-check{width:20px;height:20px;border-radius:50%;background:#11a8a4;
          display:flex;align-items:center;justify-content:center;flex-shrink:0}

        /* ── empty / error ── */
        .csp-empty{text-align:center;padding:3rem 1rem;color:#bbb;font-size:14px}
        .csp-empty-icon{font-size:36px;margin-bottom:10px}
        .csp-err{background:#fcebeb;border:0.5px solid #f09595;border-radius:10px;
          padding:12px 14px;color:#a32d2d;font-size:13px;margin:10px 18px}

        /* ── sticky footer ── */
        .csp-footer{padding:14px 18px;background:#fff;border-top:0.5px solid #eee;
          flex-shrink:0}
        .csp-sel-banner{display:flex;align-items:center;gap:10px;padding:10px 12px;
          background:#e0f5f4;border:0.5px solid #11a8a4;border-radius:9px;
          margin-bottom:10px}
        .csp-sel-name{font-size:13px;font-weight:600;color:#0c7a77;flex:1;
          white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
        .csp-sel-meta{font-size:11px;color:#0f9490}
        .csp-btn{width:100%;padding:12px;background:#11a8a4;color:#fff;border:none;
          border-radius:9px;font-size:14px;font-weight:600;cursor:pointer;
          display:flex;align-items:center;justify-content:center;gap:8px;
          transition:background .15s}
        .csp-btn:hover{background:#0c7a77}
        .csp-btn:disabled{background:#b8e8e6;cursor:not-allowed}
      `}</style>

      <div className="csp-wrap">

        {/* ── HEADER ── */}
        <div className="csp-header">
          <div className="csp-title">
            <Icon n="mapPin" size={18} /> Select a Camp
          </div>
          <div className="csp-sub">Choose the camp to record the advance payment against</div>
        </div>

        {/* ── SEARCH ── */}
        <div className="csp-search-row">
          <div className="csp-search">
            <span className="csp-search-icon"><Icon n="search" size={14} /></span>
            <input
              ref={searchRef}
              placeholder="Search by name, location, district…"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            {search && (
              <button className="csp-clear" onClick={() => { setSearch(""); searchRef.current?.focus(); }}>
                ×
              </button>
            )}
          </div>
        </div>

        {/* ── FILTER CHIPS ── */}
        <div className="csp-filters">
          {FILTERS.map(f => (
            <div key={f} className={`csp-chip${activeFilter === f ? " on" : ""}`}
              onClick={() => setFilter(f)}>
              {FILTER_LABEL[f]}
              <span className="csp-chip-count">{counts[f] || 0}</span>
            </div>
          ))}
        </div>

        {/* ── RESULT COUNT ── */}
        {!loading && !error && (
          <div className="csp-result-meta">
            {filtered.length} camp{filtered.length !== 1 ? "s" : ""}
            {search && ` for "${search}"`}
          </div>
        )}

        {/* ── SCROLLABLE LIST ── */}
        <div className="csp-list">
          {loading && <Loader text="Fetching camps…" />}
          {error  && <div className="csp-err">Failed to load camps: {error}</div>}

          {!loading && !error && filtered.length === 0 && (
            <div className="csp-empty">
              <div className="csp-empty-icon">🏕️</div>
              {search ? `No camps match "${search}"` : "No camps found"}
              {search && (
                <div style={{ marginTop:8 }}>
                  <button onClick={() => setSearch("")}
                    style={{ color:"#11a8a4", background:"none", border:"none",
                      cursor:"pointer", fontWeight:600, fontSize:13 }}>
                    Clear search
                  </button>
                </div>
              )}
            </div>
          )}

          {!loading && !error && filtered.map(c => {
            const st     = getStatus(c);
            const pill   = PILL[st] || PILL.other;
            const isSel  = selectedCamp?.id === c.id;
            const label  = c.name || c.camp_name || `Camp #${c.id}`;
            const meta   = [c.location || c.city, c.district, c.state].filter(Boolean).join(", ");
            const dates  = [c.start_date, c.end_date].filter(Boolean).join(" – ");
            const client = c.client_name || c.client || null;

            return (
              <div key={c.id}
                className={`csp-row${isSel ? " sel" : ""}`}
                onClick={() => onSelect(c)}>

                {/* avatar */}
                <div className="csp-row-avatar">⛺</div>

                {/* body */}
                <div className="csp-row-body">
                  <div className="csp-row-name">{label}</div>
                  {meta  && <div className="csp-row-meta">📍 {meta}</div>}
                  {dates && <div className="csp-row-dates">📅 {dates}</div>}
                  {client && <div className="csp-row-dates" style={{ color:"#c0a070" }}>
                    👤 {client}
                  </div>}
                </div>

                {/* right side */}
                <div className="csp-row-right">
                  {/* status pill */}
                  <div className="csp-pill"
                    style={{ background: pill.bg, color: pill.color }}>
                    <div className="csp-dot" style={{ background: pill.dot }} />
                    {FILTER_LABEL[st] || c.status || "—"}
                  </div>

                  {/* selected check OR northstar */}
                  {isSel
                    ? <div className="csp-check">
                        <svg width="11" height="9" viewBox="0 0 11 9" fill="none">
                          <path d="M1 4L4 7L10 1" stroke="#fff" strokeWidth="1.8"
                            strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    : c.is_northstar
                      ? <span style={{ fontSize:10, fontWeight:600, color:"#854f0b",
                          background:"#faeeda", borderRadius:20, padding:"2px 7px" }}>
                          ★ NS
                        </span>
                      : null
                  }
                </div>
              </div>
            );
          })}
        </div>

        {/* ── STICKY FOOTER ── */}
        <div className="csp-footer">
          {selectedCamp && (
            <div className="csp-sel-banner">
              <div style={{ fontSize:20 }}>⛺</div>
              <div style={{ flex:1, minWidth:0 }}>
                <div className="csp-sel-name">
                  {selectedCamp.name || selectedCamp.camp_name || `Camp #${selectedCamp.id}`}
                </div>
                <div className="csp-sel-meta">
                  {[selectedCamp.location || selectedCamp.city,
                    selectedCamp.district, selectedCamp.state].filter(Boolean).join(", ")}
                  {selectedCamp.start_date && ` · ${selectedCamp.start_date}`}
                </div>
              </div>
              <button onClick={() => onSelect(null)}
                style={{ color:"#aaa", background:"none", border:"none",
                  cursor:"pointer", fontSize:18, padding:0, lineHeight:1 }}>×</button>
            </div>
          )}

          <button
            className="csp-btn"
            disabled={!selectedCamp}
            onClick={onConfirm}>
            {selectedCamp
              ? <>Continue with this camp <Icon n="arrowR" size={15} /></>
              : "Select a camp to continue"}
          </button>
        </div>

      </div>
    </>
  );
}

export default CampSelectionPage;